
    var riot = require('riot')
    //src: shared/tags/modal-invite.html
riot.tag2('modal-invite',
  '<div class="Modal" onclick="{stopPropagation}"> <header class="Modal_header"> <h2 class="Modal_title">Invite your friends and colleagues to Plectica</h2> <div class="Modal_subtitle" if="{showBonusOffer()}"> Get 1 month of Plectica Pro free for each person who signs up.</div> <button class="Modal_close responsive" data-track="Invite-Flow" data-track-action="Close-Modal" onclick="{onclose}"> <svg class="Modal_close_icon" viewbox="0 0 24 24"> <path d="M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z"></path> </svg> </button> </header> <div class="Modal_body" ref="body"> <div ref="message" class="Modal_body_message" style="display: none;"></div> <div class="Modal_body_header"> <span class="Modal_body_label Modal_body_label--email">Email address</span> <span class="Modal_body_label Modal_body_label--name">Name (optional)</span> </div> <div each="{field in this.fields()}" data-row="{field}" class="invite-form"> <input type="text" data-row="{field}" class="Modal_form_input Modal_form_input--small invite-form_input_email" placeholder="someone@yourcompany.com"> <input type="text" data-row="{field}" class="Modal_form_input Modal_form_input--small invite-form_input_name" placeholder="Full Name"> <button class="remove-input" data-row="{field}" onclick="{clearInput}" tabindex="-1"> <svg class="remove-input_icon" viewbox="0 0 24 24"> <path d="M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z"></path> </svg> </button> </div> <button class="Button Button--Primary Button--Link" data-track="Invite-Flow" data-track-action="Invite-More" onclick="{addFields}">Need to invite more?</button> </div> <div class="invite-social-proof"> <svg class="invite-social-proof invite-social-proof_icon"> <use xlink:href="#user-group-icon"></use> </svg> <span> 60% of people on Plectica use it collaboratively to share ideas, provide feedback, and stay aligned with their team. </span> </div> <footer class="Modal_actions invite-footer"> <button riot-style="{!this.manualClick ? \'visibility: visible\' : \'visibility: hidden\'}" data-track="Invite-Flow" data-track-action="Dont-Show-Again" class="Button Button--Link invite-footer_dont_show" onclick="{dontShowAgain}"> Don\'t show this again </button> <div class="invite-footer_align-right"> <button data-track="Invite-Flow" data-track-action="Remind-Me-Later" class="Button Button--Outlined Button--Small invite-footer_remind_later" onclick="{remindMe}"> Remind me later </button> <button ref="submit" data-track="Invite-Flow" data-track-action="Send-Invitations" class="Button Button--Primary Button--Small" onclick="{onsubmit}"> Send Invitations </button> </div> </footer> </div>',
  '',
  'class="Modal_overlay" onclick="{onclose}" riot-style="{getStyle()}"', function(opts) {
'use strict';

var _this = this;

var _eventTracking = require('lib/event-tracking');

var _eventTracking2 = _interopRequireDefault(_eventTracking);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

this.canvas = opts.canvas;
var EmailAddressParser = require('email-addresses');
this.isOpen = false;
this.fieldCount = 3;
this.fields = function () {
  return Array(_this.fieldCount).fill().map(function (_, i) {
    return i;
  });
};

window.inviteModal = this;

this.getStyle = function () {
  if (_this.isOpen) return 'display: flex;';
  return 'display: none;';
};
this.stopPropagation = function (event) {
  return event.stopPropagation();
};

this.show = function (manualClick) {
  if (window.pageSettings && window.pageSettings.embedded) return;
  if (_this.canvas && _this.canvas.isViewOnly()) return;
  _this.manualClick = manualClick;
  _this.sending = false;
  _this.isOpen = true;
  _this.refs.submit.disabled = false;
  clearInterval(_this.modalHideTimeout);
  _this.modalHideTimeout = null;
  _this.hideMessage();
  _this.update();
  _this.trackShow();
};

this.hide = function () {
  _this.manualClick = null;
  _this.isOpen = false;
  _this.hideMessage();
  _this.update();
};

this.onclose = function (e) {
  e.stopPropagation();
  _this.isOpen = false;
  if (localStorage.getItem('invitationReminderStatus') !== 'dontShow') {
    localStorage.setItem('invitationReminderStatus', 'hidden');
  }
  _this.update();
};

this.getNameField = function (i) {
  return document.querySelector('.invite-form_input_name[data-row="' + i + '"]');
};

this.getInviteRow = function (i) {
  return document.querySelector('.invite-form[data-row="' + i + '"]');
};

this.getEmailField = function (i) {
  return document.querySelector('.invite-form_input_email[data-row="' + i + '"]');
};

this.onsubmit = function (e) {
  e.stopPropagation();
  e.preventDefault();

  var list = [];
  var errors = 0;
  if (_this.isBulk) {
    var field = _this.refs.bulkInput;
    var emailTxt = field.value.trim();
    var emails = EmailAddressParser.parseAddressList(emailTxt);
    if (!emails || !emails.length) {
      field.classList.add('error');
      return;
    };
    for (var _iterator = emails, _isArray = Array.isArray(_iterator), _i = 0, _iterator = _isArray ? _iterator : _iterator[Symbol.iterator]();;) {
      var _ref;

      if (_isArray) {
        if (_i >= _iterator.length) break;
        _ref = _iterator[_i++];
      } else {
        _i = _iterator.next();
        if (_i.done) break;
        _ref = _i.value;
      }

      var email = _ref;

      list.push({
        name: email.name || email.local,
        email: email.address
      });
    }
  } else {
    for (var _iterator2 = _this.fields(), _isArray2 = Array.isArray(_iterator2), _i2 = 0, _iterator2 = _isArray2 ? _iterator2 : _iterator2[Symbol.iterator]();;) {
      var _ref2;

      if (_isArray2) {
        if (_i2 >= _iterator2.length) break;
        _ref2 = _iterator2[_i2++];
      } else {
        _i2 = _iterator2.next();
        if (_i2.done) break;
        _ref2 = _i2.value;
      }

      var i = _ref2;

      var nameField = _this.getNameField(i);
      var emailField = _this.getEmailField(i);
      emailField.classList.remove('error');

      var name = nameField.value.trim();
      var _emailTxt = emailField.value.trim();

      if (!_emailTxt) continue;
      var _emails = EmailAddressParser.parseAddressList(_emailTxt);

      if (!_emails || !_emails.length) {
        emailField.classList.add('error');
        errors++;
        continue;
      };

      var _email = _emails[0].address;

      if (!_email) continue;

      list.push({
        name: name,
        email: _email
      });
    }
  }

  if (errors) return;

  _this.sendInvites(list);
};

this.sendInvites = function (list) {
  if (_this.sending) return;
  _this.refs.submit.disabled = true;
  _this.sending = true;
  $.ajax({
    url: '/api/user/invites',
    method: 'POST',
    data: { list: list },
    success: function success(response) {
      _this.showMessage('Invites sent');

      for (var _iterator3 = _this.fields(), _isArray3 = Array.isArray(_iterator3), _i3 = 0, _iterator3 = _isArray3 ? _iterator3 : _iterator3[Symbol.iterator]();;) {
        var _ref3;

        if (_isArray3) {
          if (_i3 >= _iterator3.length) break;
          _ref3 = _iterator3[_i3++];
        } else {
          _i3 = _iterator3.next();
          if (_i3.done) break;
          _ref3 = _i3.value;
        }

        var i = _ref3;

        var nameField = _this.getNameField(i);
        var emailField = _this.getEmailField(i);
        if (nameField) nameField.value = '';
        if (emailField) emailField.value = '';
      }

      _this.modalHideTimeout = setTimeout(function () {
        _this.hide();
        _this.sending = false;
        _this.refs.submit.disabled = false;
      }, 6000);
    },
    error: function error(err) {
      console.log('error', err);
      _this.sending = false;
      _this.refs.submit.disabled = false;
    }
  });
};

this.addFields = function () {
  _this.fieldCount += 3;
  _this.update();
  _this.scrollToBottom();
};

this.showMessage = function (msg) {
  var message = _this.refs.message;

  message.innerHTML = msg;
  message.style.zIndex = 10000;
  $(message).fadeIn();
};

this.hideMessage = function () {
  var message = _this.refs.message;

  message.innerHTML = '';
  message.style.zIndex = null;
  $(message).hide();
};

this.showBonusOffer = function () {
  if (window.referralBonusDaysRemaining) return true;
  return false;
};

this.clearInput = function (e) {
  e.stopPropagation();
  e.preventDefault();

  var target = e.target;

  var i = target.getAttribute('data-row');
  var nameField = _this.getNameField(i);
  var emailField = _this.getEmailField(i);
  if (nameField) nameField.value = '';
  if (emailField) emailField.value = '';
};

this.scrollToBottom = function () {
  _this.refs.body.scrollTo({
    left: 0,
    top: _this.refs.body.scrollHeight,
    behavior: 'smooth'
  });
};

this.dontShowAgain = function () {
  localStorage.setItem('invitationReminderStatus', 'dontShow');
  _this.hide();
};

this.remindMe = function () {
  var visitId = new Date().toDateString();
  localStorage.setItem('visits', JSON.stringify([visitId]));
  localStorage.setItem('invitationReminderStatus', 'remind-me');
  _this.hide();
};

this.on('mount', function () {
  var elements = document.querySelectorAll('.open-invite-modal');

  elements.forEach(function (elem) {
    elem.addEventListener('click', function (e) {
      _this.show(true);
      _eventTracking2.default.track({
        category: 'Invite-Flow',
        action: 'Open-Invite-Modal',
        label: 'Non-Map-Page'
      });
    });
  });

  var invitationReminderStatus = localStorage.getItem('invitationReminderStatus');
  if (['showing'].includes(invitationReminderStatus)) {
    _this.show();
  }
});

this.trackShow = function () {
  var label = window.location.href.match(/\/maps\//) ? 'Map-Page' : 'Non-Map-Page';
  _eventTracking2.default.track({
    category: 'Invite-Flow',
    action: 'Show-Modal',
    label: label
  });
};
});

    
  if (module.hot) {
    module.hot.accept()
    if (module.hot.data) {
      riot.reload('modal-invite')
    }
  }
  


//////////////////
// WEBPACK FOOTER
// ./shared/tags/modal-invite.html
// module id = 804
// module chunks = 0